function checkPopupAndSetLocale() {
    const interval = setInterval(() => {
        const shadowHost = document.querySelector('.needsclick');
        if (shadowHost) {
            clearInterval(interval);
            const shadowRoot = shadowHost.shadowRoot;
            if (!shadowRoot) return;
            const popupInterval = setInterval(() => {
                const popup = shadowRoot.querySelector('.adt-actions');
                if (popup) {
                    clearInterval(popupInterval);
                    const countryButton = shadowRoot.querySelector('.adt-disclosure-btn');
                        const shopNowButton = shadowRoot.querySelector('.adt-changeBtn');
                        shopNowButton.addEventListener('click', (event) => {
                            event.stopImmediatePropagation();
                            const redirectParam = countryButton.getAttribute('data-code');
                            popup.style.display = 'none';
                            const formLocalization = document.querySelector('.header__desktop__button > form');
                            if (redirectParam === 'PL') {
                                formLocalization.querySelector('input[name="locale_code"]').value = 'pl';
                            } else if (redirectParam === 'CZ' || redirectParam === 'SK') {
                                formLocalization.querySelector('input[name="locale_code"]').value = 'cs';
                            } else {
                                formLocalization.querySelector('input[name="locale_code"]').value = 'en';
                            }
                            document.querySelector(`.header__desktop__button .popout-list__option[data-value="${redirectParam}"]`).click();
                        });
                }
            }, 500);
            setTimeout(() => clearInterval(popupInterval), 5000);
        }
    }, 500);
    setTimeout(() => clearInterval(interval), 5000);
}

checkPopupAndSetLocale();

// select current language
const formLocalizations = document.querySelectorAll('.header__desktop__button > form, .drawer__bottom__row > form, .supporting-menu__item>form');
formLocalizations.forEach(function (formLocalization) {
    if(formLocalization !== null){
        console.log('formLocalization', formLocalization)
        formLocalization.querySelectorAll('.popout-list__option').forEach(function (item) {
            item.addEventListener('click', function (e) {
                // e.stopImmediatePropagation();
                if(item.dataset.value == 'PL'){
                    formLocalization.querySelector('input[name="locale_code"]').value = 'pl';
                }else if(item.dataset.value == 'CZ' || item.dataset.value == 'SK'){
                    formLocalization.querySelector('input[name="locale_code"]').value = 'cs';
                }else{
                    formLocalization.querySelector('input[name="locale_code"]').value = 'en';
                }
            })
        })
    }
})
// select current language
// hide popup select country (app)
function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}
function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
    return null;
}
function removeURLParameter(param) {
    const url = new URL(window.location);
    url.searchParams.delete(param);
    window.history.replaceState(null, null, url.toString());
}
function searchElement() {
    const intervalTime = 100;
    const maxTime = 3000;
    let elapsedTime = 0;
    const interval = setInterval(() => {
        const element = document.querySelector('.needsclick');
        if (element) {
            element.style.display = 'none';
            clearInterval(interval);
        }
        elapsedTime += intervalTime;
        if (elapsedTime >= maxTime) {
            clearInterval(interval);
        }
    }, intervalTime);
}
function handleRedirect() {
    const redirectParam = getURLParameter('redirect');
    removeURLParameter('redirect');
    if(getCookie('localization') == redirectParam){
        removeURLParameter('redirect');
        searchElement();
    }else{
        if (redirectParam) {
            setCookie('redirectParam', redirectParam, 30);
            // removeURLParameter('redirect');
            const countryBtn = document.querySelector(`.header__desktop__button .popout-list__option[data-value="${redirectParam}"]`)
            const formLocalization = document.querySelector('.header__desktop__button>form');
            if(redirectParam == 'PL'){
                formLocalization.querySelector('input[name="locale_code"]').value = 'pl';
            }else if(redirectParam == 'CZ' || redirectParam == 'SK'){
                formLocalization.querySelector('input[name="locale_code"]').value = 'cs';
            }else{
                formLocalization.querySelector('input[name="locale_code"]').value = 'en';
            }
            if (redirectParam) {
                const intervalTime = 100;
                const maxTime = 3000;
                let elapsedTime = 0;
                const interval = setInterval(() => {
                    if (countryBtn !== null) {
                        // removeURLParameter('redirect');
                      console.log('countryBtn', countryBtn);
                        countryBtn.click();
                        clearInterval(interval);
                    }
                    elapsedTime += intervalTime;
                    if (elapsedTime >= maxTime) {
                        // removeURLParameter('redirect');
                        clearInterval(interval);
                    }
                }, intervalTime);

            }
            searchElement();
        }
    }
}
if(getCookie('localization') != getCookie('redirectParam')){
      setCookie('redirectParam', getCookie('localization'), 30);
    }
window.onload = handleRedirect;
// hide popup select country (app)
